import React, { useCallback, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { mdiLogout } from '@mdi/js';
import Icon from '@mdi/react';
import logo from '../../../assets/logo.png';
import './Header.scss';
import AUX from '../../../hoc/AU-X/AU-X';
import { allLinks } from './links';
import CInput from '../CInput/CInput';
import moment from 'moment-jalaali';
import { useDispatch } from 'react-redux';
import { showError } from '../../../store';

const Header = () => {
  const location = useLocation();
  const theCurrent = useMemo(
    () => Object.keys(allLinks).find((key) => location.pathname.indexOf(key) > -1),
    [location]
  );
  const { links, type, options } = useMemo(() => allLinks[theCurrent] ?? {}, [theCurrent]);
  const history = useHistory();

  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());

  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  const datesUI = useCallback(
    (kind, path) => {
      const changePage = () => {
        const start = moment(Start).format('YYYY-MM-DD');
        const end = moment(End).format('YYYY-MM-DD');

        if (start >= end) {
          setMessage({ message: 'تاریخ را بدرستی انتخاب کنید', type: 'error' });
        } else {
          history.push({
            pathname: path,
            state: { date: `?start_date=${start}&end_date=${end}`, kind: kind },
          });
          setEnd(moment());
          setStart(moment());
        }
      };

      let right;
      switch (theCurrent) {
        case 'Watershed':
          right = '150px';
          break;

        case 'Lake':
        default:
          right = '165px';
          break;
      }

      return (
        <div className='datesList' style={{ right: right }}>
          <CInput
            config={{
              type: 'calendar',
              placeholder: 'تاریخ شروع',
            }}
            value={Start}
            direction='rtl'
            changed={setStart}
          />
          <CInput
            config={{
              type: 'calendar',
              placeholder: 'تاریخ پایان',
            }}
            value={End}
            direction='rtl'
            changed={setEnd}
          />
          <button onClick={changePage}>دریافت لیست</button>
        </div>
      );
    },
    [Start, End, setStart, setEnd, history, setMessage, theCurrent]
  );

  const renderLinks = useMemo(() => {
    if (!links) {
      return;
    }

    if (type === 1) {
      return links.map((link) => (
        <li key={link.url} className={location.pathname.indexOf(link.url) > -1 ? 'current' : ''}>
          {/* <NavLink className={location.pathname.indexOf(link.url) !== -1 ? 'current' : ''} to={link.url}> */}
          <NavLink to={`/${theCurrent}/${link.url}`}>{link.title}</NavLink>
        </li>
      ));
    }

    if (type === 2) {
      return links.map((link) => (
        <li key={link.url} className='hoverListHeader'>
          {link.title}
          <ul>
            {options.map((e) =>
              link.url === 'List' ? (
                <li key={e.en} className='hoverDate'>
                  {e.fa}
                  {datesUI(e, `/${theCurrent}/List`)}
                </li>
              ) : (
                <NavLink key={e.en} to={{ pathname: `/${theCurrent}/${link.url}`, state: { kind: e } }}>
                  {e.fa}
                </NavLink>
              )
            )}
          </ul>
        </li>
      ));
    }
  }, [links, type, location, theCurrent, options, datesUI]);

  return (
    <AUX>
      <div className='header'>
        <div className='center'>
          <img src={logo} alt='' />
          <h2>سامانه پایش دینامیک دریاچه ارومیه</h2>
        </div>
        <NavLink to='/logout'>
          <Icon path={mdiLogout} size={1.3} title='logout' />
        </NavLink>
      </div>
      <div className='lowerHeader'>
        <ul>{renderLinks}</ul>
      </div>
    </AUX>
  );
};

export default Header;
